module.exports = __webpack_public_path__ + "static/media/AT.e006579c.svg";